import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpEventType } from '@angular/common/http';
import { EnvironmentService } from '../../../app/services/environment.service';
import * as UserModels from '../../models/user/user';
import { HelperService } from '../helper/helper.service';
import * as Models from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService,
    private helperService: HelperService
  ) { }

  public getGuardianDictionary() {
    return this.httpClient.get<UserModels.UserDictionaryListModel>(`${this.environmentService.getApiURL()}/user/guardian`);
  }

  public setContextUser(User: UserModels.User) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<UserModels.UserModel>(`${this.environmentService.getApiURL()}/user/set-context`, User, options);
  }


  public getList(Search: UserModels.UserSearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<UserModels.UserPreviewListModel>>(`${this.environmentService.getApiURL()}/user/list`, Search, options);
  }

  public create(User: Models.Request<UserModels.UserEditModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<UserModels.UserEditModel>>(`${this.environmentService.getApiURL()}/user/create`, User, options);
  }

  public get(User: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<UserModels.UserEditModel>>(`${this.environmentService.getApiURL()}/user/get`, User, options);
  }

  public set(User: Models.Request<UserModels.UserEditModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<UserModels.UserEditModel>>(`${this.environmentService.getApiURL()}/user/set`, User, options);
  }

  public setUserPreview(User: Models.Request<UserModels.UserPreviewListModel>) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<UserModels.UserPreviewListModel>>(`${this.environmentService.getApiURL()}/user/set-preview`, User, options);
  }

  public remove(User: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseBase>(`${this.environmentService.getApiURL()}/user/remove`, User, options);
  }
}
